import { defaultComponents as selectMenuDefaultComponents } from 'bold-ui/lib/components/Select/SelectSingle/SelectDownshiftMenu'
import React from 'react'

import {
  MaisItensSelectMenuItem,
  MaisItensSelectMenuItemProps,
} from '../../MaisItensSelectMenuItem/MaisItensSelectMenuItem'
import {
  LotacaoAgendaSelectFieldItemProps,
  LotacaoAgendaSelectMaxItems,
  LotacaoAgendaSelectTipoGrupoVazio,
} from '../model-lotacaoAgendaSelectField'
import { LotacaoAgendaSelectGrupoVazioItem } from './LotacaoAgendaSelectGrupoVazioItem'

interface LotacaoAgendaSelectSemAcessoRapidoItemProps
  extends LotacaoAgendaSelectFieldItemProps,
    MaisItensSelectMenuItemProps {}

export function LotacaoAgendaSelectSemAcessoRapidoItem(props: LotacaoAgendaSelectSemAcessoRapidoItemProps) {
  const { index, selectMaxItems: selectSize, ...rest } = props

  const { item, renderItem } = rest

  if (item === LotacaoAgendaSelectTipoGrupoVazio.VAZIO) {
    return <LotacaoAgendaSelectGrupoVazioItem grupoTipo={item} hideAcessoRapido />
  }

  if (item === LotacaoAgendaSelectMaxItems.RODAPE_MAIS_ITENS) {
    return <MaisItensSelectMenuItem selectMaxItems={selectSize} />
  }

  return (
    <selectMenuDefaultComponents.Item index={index} {...rest}>
      {renderItem(item)}
    </selectMenuDefaultComponents.Item>
  )
}
